<template>
  <v-dialog v-model="dialog" content-class="v-dialog--custom"
    :fullscreen="$vuetify.breakpoint.xsOnly">
    <v-card>
      <v-card-text>
        <vue-html2pdf
          :show-layout="false"
          :float-layout="false"
          :enable-download="true"
          :preview-modal="false"
          :filename="`${client.companyName}_quote_${item.id}`"
          :pdf-quality="2"
          :manual-pagination="true"
          ref="html2Pdf"
           :pdfContentWidth="'100%'"
        >
          <section slot="pdf-content">
            <section class="pdf-item">
              <div class="invoice">
                <table width="100%" class="table">
                  <tr>
                    <td width="50%" class="text-left">
                      <!-- <img src="/static/assets/ling-logo.png" height="40" /> -->
                    </td>
                    <td width="50%" class="text-right"><h2>Bid</h2></td>
                  </tr>
                </table>

                <hr style="border: 0.5px solid #cfcfcf" />

                <table width="100%" class="table">
                  <tr>
                    <td width="50%" class="text-left">
                      <span class="font-weight-black">Date:</span>
                      {{ item.date | formatDate }}
                    </td>
                    <td width="50%" class="text-right">
                      <span class="font-weight-black">Bid No:</span>
                      {{ item.id }}
                    </td>
                  </tr>
                </table>

                <hr style="border: 0.5px solid #cfcfcf" />

                <table width="100%" class="table">
                  <tr>
                    <td width="50%" class="text-left">
                      <div class="font-weight-black">Bid To:</div>
                      <div><company-address :item="client" /></div>
                    </td>
                    <td width="50%" class="text-right">
                      <div class="font-weight-black">Pay To:</div>
                      <div><company-address /></div>
                    </td>
                  </tr>
                </table>

                <div class="card">
                  <table
                    width="100%"
                    class="table"
                    cellpadding="0"
                    cellspacing="0"
                  >
                    <thead>
                      <tr>
                        <th class="text-left" width="20%">Service</th>
                        <th class="text-left" width="50%">Description</th>
                        <th width="12.5%">Rate</th>
                        <th width="12.5%">QTY</th>
                        <th width="12.5%" v-show="isAdmin">Cost</th>
                        <th width="12.5%">Amount</th>
                      </tr>
                    </thead>
                  </table>

                  <div
                    style="
                      page-break-inside: avoid !important;
                      margin: 10pt 0pt;
                    "
                    v-for="(item, index) in item.lineItems"
                    :key="index"
                  >
                    <table
                      width="100%"
                      class="table"
                      cellpadding="0"
                      cellspacing="0"
                      border="1"
                    >
                      <tbody>
                        <tr>
                          <td
                            class="text-left"
                            style="
                              vertical-align: top;
                              border-bottom: 1px solid #cfcfcf;
                            "
                            width="20%"
                          >
                            {{ item.title }}
                          </td>
                          <td
                            class="text-left"
                            style="
                              vertical-align: top;
                              border-bottom: 1px solid #cfcfcf;
                            "
                            width="50%"
                          >
                            {{ item.date | formatDate }}<br />
                            <div
                              v-html="item.description"
                              style="line-break: auto; white-space: pre-line"
                            ></div>
                          </td>
                          <td
                            class="text-right"
                            style="
                              vertical-align: top;
                              border-bottom: 1px solid #cfcfcf;
                            "
                            width="12.5%"
                          >
                            {{ item.price | formatPrice }}
                          </td>
                          <td
                            class="text-right"
                            style="
                              vertical-align: top;
                              border-bottom: 1px solid #cfcfcf;
                            "
                            width="12.5%"
                          >
                            {{ item.quantity }}
                          </td>
                          <td
                            class="text-right"
                            style="
                              vertical-align: top;
                              border-bottom: 1px solid #cfcfcf;
                            "
                            v-show="isAdmin"
                            width="12.5%"
                          >
                            {{ item.cost | formatPrice }}
                          </td>
                          <td
                            class="text-right"
                            style="
                              vertical-align: top;
                              border-bottom: 1px solid #cfcfcf;
                            "
                            width="12.5%"
                          >
                            {{
                              (parseFloat(item.price) *
                                parseFloat(item.quantity))
                                | formatPrice
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div
                    style="
                      page-break-inside: avoid !important;
                      margin: 10pt 0pt;
                    "
                  >
                    <table
                      width="100%"
                      class="table"
                      cellpadding="0"
                      cellspacing="0"
                      border="1"
                    >
                      <tfoot>
                        <tr>
                          <th :colspan="isAdmin ? 5 : 4" class="text-right">
                            <span class="font-weight-black">Sub Total:</span>
                          </th>
                          <th class="text-right">
                            {{ totalSub | formatPrice }}
                          </th>
                        </tr>
                        <tr>
                          <th :colspan="isAdmin ? 5 : 4" class="text-right">
                            <span class="font-weight-black">Tax:</span>
                          </th>
                          <th class="text-right">
                            {{ totalTax | formatPrice }}
                          </th>
                        </tr>
                        <tr>
                          <th :colspan="isAdmin ? 5 : 4" class="text-right">
                            <span class="font-weight-black">Total:</span>
                          </th>
                          <th class="text-right">
                            {{ (totalSub + totalTax) | formatPrice }}
                          </th>
                        </tr>

                        <!-- <tr>
                      <th :colspan="isAdmin ? 5 : 4" class="text-right">
                        <span class="font-weight-black">Grand Total Due:</span>
                      </th>
                      <th class="text-right">
                        {{ totalGrandDue | formatPrice }}
                      </th>
                    </tr> -->
                        <tr v-show="isAdmin">
                          <th :colspan="isAdmin ? 5 : 4" class="text-right">
                            <span class="font-weight-black">Total Cost:</span>
                          </th>
                          <th class="text-right">
                            {{ totalCost | formatPrice }}
                          </th>
                        </tr>
                        <tr v-show="isAdmin">
                          <th :colspan="isAdmin ? 5 : 4" class="text-right">
                            <span class="font-weight-black">Total Profit:</span>
                          </th>
                          <th class="text-right">
                            {{ totalProfit | formatPrice }}
                          </th>
                        </tr>
                        <tr v-show="isAdmin">
                          <th class="text-right" colspan="3">
                            <span class="font-weight-black">Parts:</span>
                          </th>
                          <th class="text-right">
                            {{ totalPart | formatPrice }}
                          </th>
                          <th class="text-right">
                            <span class="font-weight-black">Income:</span>
                          </th>
                          <th class="text-right">
                            {{ incomePart | formatPrice }}
                          </th>
                        </tr>
                        <tr v-show="isAdmin">
                          <th class="text-right" colspan="3">
                            <span class="font-weight-black">Labor:</span>
                          </th>
                          <th class="text-right">
                            {{ totalLabor | formatPrice }}
                          </th>
                          <th class="text-right">
                            <span class="font-weight-black">Income:</span>
                          </th>
                          <th class="text-right">
                            {{ incomeLabor | formatPrice }}
                          </th>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>

                <div>
                  <div class="text-center p-10" style="padding: 20px">
                    <span class="font-weight-black">NOTE</span> : This is
                    computer generated receipt and does not require physical
                    signature.
                  </div>
                </div>
              </div>
            </section>
          </section>
        </vue-html2pdf>
      </v-card-text>
      <v-card-actions class="text-right">
        <v-btn @click="closeDelete">Close</v-btn>
        <v-btn class="info" @click="generateReport()" text :loading="loading"
          >Download PDF <v-icon>file_download</v-icon></v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import formatterMixin from "src/mixins/formatterMixin";
import CompanyAddress from "components/CompanyAddress";
import VueHtml2pdf from "vue-html2pdf";
export default {
  props: {
    isAdmin: Boolean,
    item: Object,
    show: [Boolean, String],
  },
  mixins: [formatterMixin],
  components: {
    CompanyAddress,
    VueHtml2pdf,
  },
  data() {
    return {
      dialog: false,
      loading: false,
    };
  },
  computed: {
    ...mapState({
      quote: (state) => state.quote,
      alert: (state) => state.alert,
      account: (state) => state.account,
      client: (state) => state.client.single,
      company: (state) => state.account.data.account,
    }),

    isPaid() {
      return this.item.status == "paid" || this.item.status == "Paid";
    },

    fromUser() {
      let html = `Ling Enterprises,
                      <br />Inc 2642 Escondido Ave, <br />San Diego CA 92123
                      <br />Office: (858) 598-3885 <br />Mobile: (858) 349-2115
                      <br />luke@sling3.com`;

      // const {} = this.account.data.user;

      return html;
    },

    toClient() {
      let words = [];
      const { companyName, address, city, state, zipcode, email, phoneNumber } =
        this.client.single;

      if (companyName) {
        words.push(`<b>${companyName}</b>`);
      }

      if (address || city || state || zipcode) {
        words.push(`${address} ${city} ${state} ${zipcode}`);
      }

      if (phoneNumber) {
        words.push(`Mobile: ${phoneNumber}`);
      }

      if (email) {
        words.push(email);
      }
      return words.join("<br />");
    },

    totalSub() {
      let total = 0;
      if (this.item && this.item.lineItems && this.item.lineItems.length > 0) {
        this.item.lineItems.map((item) => {
          total += parseFloat(item.price) * parseFloat(item.quantity);
        });
      }
      return total;
    },

    totalTax() {
      return this.item.quoteTaxAmount;
    },

    totalCost() {
      let total = 0;
      if (this.item && this.item.lineItems && this.item.lineItems.length > 0) {
        this.item.lineItems.map((item) => {
          total += parseFloat(item.cost) * parseFloat(item.quantity);
        });
      }
      return total;
    },

    totalProfit() {
      return this.totalSub - this.totalCost;
    },

    totalGrandDue() {
      if (this.item.status === "Overdue") {
        return this.item.quoteAmount;
      }
      return 0;
    },

    totalPart() {
      let total = 0;
      if (this.item && this.item.lineItems && this.item.lineItems.length > 0) {
        this.item.lineItems
          .filter((item) => item.itemType == "Parts")
          .map((item) => {
            total += this.subTotalPrice(item);
          });
      }
      return total;
    },

    totalCostPart() {
      let total = 0;
      if (this.item && this.item.lineItems && this.item.lineItems.length > 0) {
        this.item.lineItems
          .filter((item) => item.itemType == "Parts")
          .map((item) => {
            total += this.subTotalCost(item);
          });
      }
      return total;
    },

    incomePart() {
      return this.totalPart - this.totalCostPart;
    },

    totalLabor() {
      let total = 0;
      if (this.item && this.item.lineItems && this.item.lineItems.length > 0) {
        this.item.lineItems
          .filter((item) => item.itemType == "Labor")
          .map((item) => {
            total += this.subTotalPrice(item);
          });
      }
      return total;
    },

    totalCostLabor() {
      let total = 0;
      if (this.item && this.item.lineItems && this.item.lineItems.length > 0) {
        this.item.lineItems
          .filter((item) => item.itemType == "Labor")
          .map((item) => {
            total += this.subTotalCost(item);
          });
      }
      return total;
    },

    incomeLabor() {
      return this.totalLabor - this.totalCostLabor;
    },
  },
  watch: {
    async item(n) {
      if (n.clientId) {
        await this.getClientById(this.item.clientId);
      }
    },
    show(n, o) {
      if (n && !o) {
        this.dialog = true;
      }
    },
    dialog(n, o) {
      if (!n && o) {
        this.closeDelete();
      }
    },
  },
  methods: {
    ...mapActions({
      getClientById: "client/getById",
    }),
    subTotalPrice(item) {
      return parseFloat(item.quantity) * parseFloat(item.price);
    },

    subTotalCost(item) {
      return parseFloat(item.quantity) * parseFloat(item.cost);
    },

    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
    closeDelete() {
      this.dialog = false;
      this.$store.dispatch("alert/clear");
      this.$emit("onClosed");
    },
  },

  async mounted() {},
};
</script>